const getNewCountString = (newCount: number) => (newCount > 0 ? `${newCount} New, ` : '');

export const getListenWiseClassStatuses = (
  newCount: number,
  submittedCount: number,
  startedCount: number,
  notStartedCount: number,
) =>
  `${getNewCountString(newCount)} ${submittedCount} Submitted, ${startedCount} Started, ${notStartedCount} Not Started`;

export const getLingoliftClassStatuses = (
  newCount: number,
  completedCount: number,
  startedCount: number,
  notStartedCount: number,
  returnedCount: number,
) =>
  `${getNewCountString(newCount)} ${completedCount} Completed, ${startedCount} Started, ${notStartedCount} Not Started, ${returnedCount} Returned`;
